import { render, staticRenderFns } from "./base-divider.vue?vue&type=template&id=fe2f832e&"
var script = {}
import style0 from "./base-divider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports